const parseDateToMillisecond = (date) => new Date(date).getTime();
export const getExtension = (item) => {
    let extension = '';
    if (item?.resourceSummaryGroups?.[0]?.sample?.type === 'file') {
        const fileName = item?.resourceSummaryGroups?.[0]?.sample?.name;
        const parts = fileName.split('.');
        extension = parts[parts.length - 1];
    }
    return extension;
};
export const getType = (item) => {
    const group = item?.resourceSummaryGroups?.[0];
    if (item?.resourceSummaryGroups && item.resourceSummaryGroups.length > 1) {
        return 'mixedExtensionName';
    }
    switch (group?.type) {
        case 'file':
            switch (group.subType) {
                case 'image':
                    return 'photoExtensionName';
                case 'audio':
                    return 'audioExtensionName';
                case 'video':
                    return 'videoExtensionName';
                default:
                    return 'documentExtensionName';
            }
        case 'playlist':
            return group.subType === 'audio' ? 'audioAlbumExtensionName' : 'photoAlbumExtensionName';
        default:
            return 'folderExtensionName';
    }
};
export const shareResponseParser = (shares) => {
    return shares.map((item) => {
        const type = getType(item);
        const obj = {
            ...item?.resourceSummaryGroups?.[0]?.sample,
            name: item.name,
            count: item.totalResourceCount,
            createdAt: parseDateToMillisecond(item.lastModifiedDate),
            uri: item?.resourceSummaryGroups?.[0]?.sample?.location,
            uid: item.uid,
            nodeId: item.uid,
            type,
            subType: null,
            extension: getExtension(item),
            originalItem: item,
        };
        return obj;
    });
};
